import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import TrackPlanner from "./pages/TrackPlanner";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
    return (
        <LanguageProvider>
        <div className="App">
            <BrowserRouter basename="/apps/rutaforge">
                <Routes>
                    <Route path="/" element={<TrackPlanner />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-center"
                richColors
                offset={120}
                toastOptions={{
                    style: {
                        background: "#14171c",
                        border: "1px solid rgba(255,255,255,0.12)",
                        color: "#e9ecef",
                        fontFamily: "DM Sans, sans-serif",
                    },
                }}
            />
        </div>
        </LanguageProvider>
    );
}

export default App;